module.exports = __webpack_public_path__ + "img/shaizi.1f2f691d.png";